import { TableColumns } from 'interfaces';

export const LEADS_PAGE_TITLE = 'Leads';

export const LEADS_PAGE_DESCRIPTION = 'View all leads from the PlanD webside.';

export const LEADS_TABLE_COLUMNS: TableColumns[] = [
  { id: 'id', title: 'Id', sortable: true },
  { id: 'name', title: 'Name' },
  { id: 'email', title: 'Email Address' },
  { id: 'phone_number', title: 'Phone Number' },
  { id: 'created_at', title: 'Date Created', sortable: true },
  { id: 'reason_for_interest', title: 'Reason for Interest' },
  { id: 'button', title: '' },
];

export const GET_INVESTORS_FILTER = 'filter[userble_type]=investor';
